<template>
  <v-container fluid class="grey lighten-4 px-0 pt-0 mt-10 pb-16">
    <v-responsive width="960" class="mx-auto notice-wrap">
      <v-card
        v-if="template && info && rules"
        color="white"
        class="guide-common notice-register"
        style="position: relative;"
      >
        <!-- <v-divider></v-divider> -->
        <CVQuickMenu
          v-if="quickmenuOn"
          :titles="titles"
          :template="template"
          @saveConfirm="saveConfirm"
          :isReadonly="isReadonly"
        ></CVQuickMenu>
        <CVCategory
          ref="CVTypeCategory"
          :ch="obj.ch"
          :ci="obj.ci"
          :info="info"
          :isReadonly="isReadonly"
          @save="componentSave"
        ></CVCategory>
        <v-divider></v-divider>
        <template v-for="(item, i) in componentArray">
          <component
            :applNo="applNo"
            :ref="item"
            :id="'nav-' + recapitalize(item.replace('CV', ''))"
            :key="'comp' + i"
            :is="item"
            :template="template"
            :opts="obj.opts"
            :info="info"
            :rules="rules"
            :dynamicScreenTagClass="screenDynamicClass"
            :leftRoundedClass="leftRoundedClass"
            :rightRoundedClass="rightRoundedClass"
            :isReadonly="isReadonly"
            v-bind="itemHeler()"
            @save="componentSave"
            @delete="componentDelete"
            @applyFile="componentApplyFile"
          ></component>
          <v-divider :key="'div' + i"></v-divider>
        </template>
        <!-- <i-btn elevation="0" color="primary" block @click="saveConfirm"
          ><v-icon class="material-icons-outlined">check</v-icon>지원서
          제출</i-btn
        > -->
      </v-card>
      <v-row class="d-flex justify-center py-6 px-8">
        <v-col cols="12" v-if="!isReadonly">
          <i-btn elevation="0" color="primary" block @click="checkDuplApply"
            ><v-icon class="material-icons-outlined">check</v-icon
            >{{ $t('지원서 제출') }}</i-btn
          >
        </v-col>
      </v-row>
    </v-responsive>
  </v-container>
</template>
<script>
import { API, getAuthJson, postAuthJson } from '@/api/network';
import { DialogMixin } from '@/mixin/dialog.js';
import { LoadingMixin } from '@/mixin/loading.js';

import { validateDate } from '@/utils/validation';

import CVQuickMenu from '@/components/items/resume/CVQuickMenu.vue';
import CVCategory from '@/components/items/resume/CVCategory.vue';
import CVTypeBase from '@/components/items/resume/CVTypeBase.vue';
import CVTypeEtc from '@//components/items/resume/CVTypeEtc.vue';
import CVTypeAddition from '@/components/items/resume/CVTypeAddition.vue';
import CVTypeLanguage from '@/components/items/resume/CVTypeLanguage.vue';
import CVTypeLicense from '@/components/items/resume/CVTypeLicense.vue';
import CVTypeMilitary from '@/components/items/resume/CVTypeMilitary.vue';
import CVTypeCareer from '@/components/items/resume/CVTypeCareer.vue';
import CVTypeSchool from '@/components/items/resume/CVTypeSchool.vue';
import CVTypeSelfIntro from '@/components/items/resume/CVTypeSelfIntro.vue';
import CVTypeFile from '@/components/items/resume/CVTypeFile.vue';
import CVTypeCustom from '@/components/items/resume/CVTypeCustom.vue';
import CVTypeResumeUpload from '@/components/items/resume/CVTypeResumeUpload.vue';
import CVTypeAwards from '@/components/items/resume/CVTypeAwards.vue';
import CVTypeEducation from '@/components/items/resume/CVTypeEducation.vue';
import CVTypeCareerOverseas from '@/components/items/resume/CVTypeCareerOverseas.vue';
import CVTypeProject from '@/components/items/resume/CVTypeProject.vue';
import CVTypeSns from '@/components/items/resume/CVTypeSns.vue';
import CVTypeComUses from '@/components/items/resume/CVTypeComUses.vue';
import CVTypeAbilityIntro from '@/components/items/resume/CVTypeAbilityIntro.vue';
import { isObject } from '@/utils/util';

// eslint-disable-next-line no-unused-vars
function getAllForm(arr = []) {
  if (
    this.$el instanceof HTMLFormElement &&
    this.$el.className.includes('v-form')
  ) {
    arr.push(this);
  } else if (this.$children.length) {
    this.$children.forEach(children => getAllForm.call(children, arr));
  }
  return arr;
}

const paramClean = obj => {
  if (isObject(obj)) {
    const clone = Array.isArray(obj) ? [] : {};
    Object.keys(obj).forEach(key => (clone[key] = paramClean(obj[key])));
    return clone;
  } else if (typeof obj == 'string') return obj.replace(/[\uFFFD\b]/g, ' ');
  return obj;
};

export default {
  mixins: [DialogMixin, LoadingMixin],
  components: {
    CVQuickMenu,
    CVCategory,
    CVTypeBase,
    CVTypeEtc,
    CVTypeAddition,
    CVTypeLanguage,
    CVTypeLicense,
    CVTypeMilitary,
    CVTypeCareer,
    CVTypeSchool,
    CVTypeSelfIntro,
    CVTypeFile,
    CVTypeCustom,
    CVTypeAwards,
    CVTypeEducation,
    CVTypeCareerOverseas,
    CVTypeProject,
    CVTypeSns,
    CVTypeComUses,
    CVTypeAbilityIntro,
    CVTypeResumeUpload,
  },
  computed: {
    componentArray() {
      return this.items;
    },
    quickmenuOn() {
      return (
        this.$vuetify.breakpoint.name != 'sm' &&
        this.$vuetify.breakpoint.name != 'xs'
      );
    },
    screenDynamicClass: function() {
      return {
        'd-md-block':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
        'd-block':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
        'mt-2':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
        'mb-2':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    leftRoundedClass: function() {
      return {
        'rounded-l':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
        'rounded-r-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
    rightRoundedClass: function() {
      return {
        'rounded-r':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
        'rounded-l-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
  },
  props: {
    obj: { type: Object },
    titles: { type: Array },
    isReadonly: { type: Boolean },
  },
  mounted() {
    this.setting();
  },
  data: () => ({
    applyLazyValidate: false,
    delimeter: '#',
    items: [],
    template: null,
    info: null,
    rules: null,
    applNo: null,
    bannerValid: false,
    saveurl: {
      category: '/cv/category',
      base: '/cv/base',
      etc: '/cv/etc',
      addition: '/cv/addition',
      language: '/cv/language',
      license: '/cv/license',
      military: '/cv/military',
      school: '/cv/school',
      career: '/cv/career',
      selfIntro: '/cv/selfIntro',
      file: '/cv/fileInfo',
      custom: '/cv/custom',
      careerOverseas: '/cv/careeroverseas',
      education: '/cv/education',
      awards: '/cv/awards',
      project: '/cv/project',
      sns: '/cv/sns',
      comUses: '/cv/comUses',
      abilityIntro: '/cv/abilityIntro',
    },
    deleteUrl: {
      school: '/cv/school/delete',
      license: '/cv/license/delete',
      language: '/cv/language/delete',
      career: '/cv/career/delete',
      file: '/cv/fileInfo/delete',
      careerOverseas: '/cv/careeroverseas/delete',
      education: '/cv/education/delete',
      awards: '/cv/awards/delete',
      project: '/cv/project/delete',
      comUses: '/cv/comUses/delete',
    },
  }),
  methods: {
    itemHeler() {
      const helper = (key, callback, defalutValue) =>
        this.obj?.opts?.hasOwnProperty(key)
          ? callback(
              this.obj.opts[key] || {
                oDirectInput: 'N',
                oFormat: null,
                oGuide: '',
                oItems: '',
                oLength: null,
                oLimitCount: null,
                oMaxLength: 100,
                oMinLength: 0,
                oRequireYn: 'N',
              },
              defalutValue,
            ) ?? defalutValue
          : defalutValue;

      return {
        itemArray: key => helper(key, option => option.oItems?.split('#'), []),
        itemLabel: key =>
          helper(
            key,
            (option, label) =>
              (option.oRequireYn == 'Y' ? '*' : '') + this.$t(label),
            this.template?.[key],
          ),

        itemDirectInput: key => helper(key, option => option.oDirectInput, 'N'),
      };
    },
    rulesset: function() {
      if (this.obj.opts) {
        var $this = this;
        this.rules = {
          required(itemKey, useLazyValidate = false) {
            if (!$this.obj.opts.hasOwnProperty(itemKey)) return () => true;

            if ($this.obj.opts[itemKey].oRequireYn === 'Y')
              return v =>
                (useLazyValidate && !$this.applyLazyValidate) ||
                !!v ||
                '필수 정보입니다.';
            else return () => true;
          },
          maxlength(itemKey) {
            if ($this.obj.opts.hasOwnProperty(itemKey)) {
              if ($this.obj.opts[itemKey].oLength)
                return v =>
                  !v ||
                  v.length <= $this.obj.opts[itemKey].oLength ||
                  '최대 길이를 초과하였습니다.';
              else return () => true;
            } else {
              return () => true;
            }
          },
          //maxlength()의 oLength을 oMaxLength로 사용하기 위에 추가
          maxLength(itemKey) {
            if ($this.obj.opts.hasOwnProperty(itemKey)) {
              if ($this.obj.opts[itemKey].oMaxLength)
                return v =>
                  !v ||
                  v.length <= $this.obj.opts[itemKey].oMaxLength ||
                  '최대 길이를 초과하였습니다.';
              else return true;
            } else {
              return () => true;
            }
          },
          minlength(itemKey) {
            if ($this.obj.opts.hasOwnProperty(itemKey)) {
              if ($this.obj.opts[itemKey].oMinLength)
                return v =>
                  !v ||
                  v.length >= $this.obj.opts[itemKey].oMinLength ||
                  '최소 길이보다 적습니다.';
              else return () => true;
            } else {
              return () => true;
            }
          },
          dateFormat(itemKey) {
            if ($this.obj.opts.hasOwnProperty(itemKey)) {
              if ($this.obj.opts[itemKey].oFormat)
                return v =>
                  !v ||
                  validateDate($this.obj.opts[itemKey].oFormat, v) ||
                  '형식에 맞지 않습니다.';
              else return () => true;
            } else {
              return () => true;
            }
          },
        };
      }
    },

    requiredYnDefaultChar: function(char) {
      return typeof char === 'undefined' ? 'N' : char;
    },
    setting: function() {
      let $this = this;
      this.items = [];
      const close = this.$showLoading();
      this.rulesset();
      this.titles.forEach(function(v) {
        let i = 'CV' + $this.capitalize(v);
        $this.items.push(i);
      });
      const p = { annoId: this.$route.params.annoId };
      getAuthJson(
        'api/v1/' + this.$route.params.tenantKey + '/announce/cv/column',
        p,
      )
        .then(res => {
          if (res && res.data) {
            this.template = res.data;
            if (res.data.applNo) {
              //이력서 정보 가져오기
              this.applNo = res.data.applNo;
              const param = {
                annoId: this.$route.params.annoId,
                applNo: res.data.applNo,
              };

              const close2 = this.$showLoading();
              postAuthJson(
                'api/v1/' + this.$route.params.tenantKey + '/cv/data',
                param,
              )
                .then(async response => {
                  if (response && response.data) {
                    const { data } = await API.getAuthJson('/cv/files', param);
                    response.data.fileMap = data.reduce(
                      (a, c) => Object.assign(a, { [c.fileId]: c }),
                      {},
                    );
                    this.info = response.data;
                  }
                })
                .catch(error => {
                  console.log(error);
                })
                .finally(close2);
            }
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(close);
    },
    capitalize: function(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    recapitalize: function(str) {
      return str.charAt(0).toLowerCase() + str.slice(1);
    },
    valid: async function() {
      this.bannerValid = this.$parent.imageValid();
      var isValid = this.$refs.CVTypeCategory.valid();
      const saveFormValidateStack = [];

      for (var i = 0; i < this.items.length && isValid; i++) {
        var v = this.items[i];

        isValid = this.$refs[v][0].valid();

        const saveForm = this.$refs[v][0].$refs?.saveForm;
        if (
          saveForm?.$el instanceof HTMLFormElement &&
          saveForm.inputs.some($field => $field.value)
        ) {
          this.applyLazyValidate = true;
          try {
            const target = v.replace('CVType', '');

            !saveForm.validate() &&
              saveFormValidateStack.push(
                this.template[
                  target[0].toLocaleLowerCase() + target.slice(1) + 'Title'
                ],
              );
          } catch (error) {
            console.warn(error);
          }
          this.applyLazyValidate = false;
        }
      }

      isValid &&
        saveFormValidateStack.length &&
        (await this.$confirm(
          `${saveFormValidateStack.join()}에 저장되지 않은 항목이 존재합니다.<br/>
      무시하고 제출 하시겠습니까?
      `,
        ).then(answer => {
          isValid = answer;
        }));

      return isValid;
    },
    componentSave: async function(param, name, idx) {
      if (this.isReadonly) return;
      var typeName = 'CVType' + this.capitalize(name);

      var componentObject =
        name == 'category' ? this.$refs[typeName] : this.$refs[typeName][0];

      if (idx === -1) {
        /**
         * 저장되는 섹션이 list 형태인 경우
         * 추가되서 자장된항목 ref="updateForm"
         * 아직 저장되지 않은 항목 ref="saveForm" 을 사용 할 것을 약속해야함
         */
        this.applyLazyValidate = true;
        await this.$nextTick();
        const vali = componentObject.$refs.saveForm.validate();
        this.applyLazyValidate = false;
        if (!vali) return;
      }
      if (componentObject && this.saveurl[name]) {
        // postAuthJson(
        //   'api/v1/' + this.$route.params.tenantKey + this.saveurl[name],
        //   paramClean(param),
        // )
        API.postAuthJson(this.saveurl[name], paramClean(param))
          .then(res => {
            componentObject.savecallback(res, idx);
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    componentDelete: function(param, name, idx) {
      var typeName = 'CVType' + this.capitalize(name);
      var componentObject = this.$refs[typeName][0];

      if (componentObject && this.deleteUrl[name]) {
        postAuthJson(
          'api/v1/' + this.$route.params.tenantKey + this.deleteUrl[name],
          param,
        )
          .then(res => {
            componentObject.deletecallback(res, idx);
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    componentApplyFile(name, fileId) {
      var typeName = 'CVType' + this.capitalize(name);
      var componentObject = this.$refs[typeName][0];
      if (this.isReadonly) return;
      const p = { annoId: this.$route.params.annoId };
      postAuthJson(
        'api/v1/' + this.$route.params.tenantKey + '/cv/file/apply/' + fileId,
        p,
      )
        .then(res => {
          componentObject.applyFilecallback(res);
        })
        .catch(error => {
          console.log(error.response);
        });
    },
    async saveConfirm() {
      let message = '';
      const itemCount = [];
      const chkItems = [
        { ref: 'CVTypeSchool', prop: 'schools', label: '학력' },
        { ref: 'CVTypeCareer', prop: 'careers', label: '경력' },
        { ref: 'CVTypeLanguage', prop: 'languages', label: '어학' },
        { ref: 'CVTypeLicense', prop: 'licenses', label: '자격증' },
        { ref: 'CVTypeAwards', prop: 'awardses', label: '수상내역' },
        {
          ref: 'CVTypeCareerOverseas',
          prop: 'careerOverseas',
          label: '해외경력',
        },
        { ref: 'CVTypeEducation', prop: 'educations', label: '교육사항' },
        { ref: 'CVTypeSelfIntro', prop: 'selfIntros', label: '자소서 항목' },
        {
          ref: 'CVTypeAbilityIntro',
          prop: 'abilityIntros',
          label: '기술서 항목',
        },
      ];

      for (const item of chkItems) {
        const refArray = this.$refs[item.ref];

        if (refArray && refArray[0][item.prop]) {
          const count = refArray[0][item.prop].length;
          itemCount.push({ label: item.label, count });
        }
      }

      for (const { label, count } of itemCount) {
        message += ` ${label}: ${count} 건\n`;
      }

      const answer = await this.$confirm(
        '입력된 이력정보는 다음과 같습니다.\n\n' +
          message +
          '\n지원서 제출 후 서류접수 기간 내 제출취소 후 수정이 가능합니다. 정말 제출하시겠습니까?',
      );

      answer && this.save();
    },
    save: async function() {
      if (await this.valid()) {
        if (!this.bannerValid) {
          this.hideLoading();
          this.$showAlert('사진이 등록되지 않았습니다.');
        } else {
          const p = {
            annoId: this.$route.params.annoId,
            applNo: this.applNo,
          };
          postAuthJson(
            'api/v1/' + this.$route.params.tenantKey + '/cv/data/submit',
            p,
          )
            .then(res => {
              this.hideLoading();

              var v = '';
              if (res.data.status === 'FAIL') {
                v = {
                  message:
                    res.data.message || '지원서 제출 중 오류가 발생하였습니다.',
                  title: '',
                  callback: null,
                };
              } else {
                v = {
                  message: '지원서가 제출되었습니다.',
                  title: '',
                  callback: this.savecallback,
                };
              }
              this.$showAlert(v);
            })
            .catch(error => {
              this.hideLoading();

              console.log(error);
            });
        }
      } else {
        this.hideLoading();

        this.items.forEach(v => {
          this.$refs[v][0].$refs?.saveForm?.resetValidation();
        });

        await this.$showAlert(
          '필수 입력사항이 모두 입력되지 않았습니다. \n작성한 지원서를 다시 한번 확인해 주세요',
        );

        document
          .querySelector('.error--text')
          ?.scrollIntoView({ block: 'center' }); // smooth 는 스크롤이 끊길 우려가 있음
      }
    },
    savecallback: function() {
      this.hideLoading();
      this.$router.push('/console/' + this.$route.params.tenantKey);
    },
    checkDuplApply: function() {
      const p = {
        annoId: this.$route.params.annoId,
      };
      /* 중복지원 체크 */
      getAuthJson(
        'api/v1/' + this.$route.params.tenantKey + '/checkDuplApply',
        p,
      )
        .then(res => {
          if (res.status !== 200) {
            console.log('CUSTOM INFO SAVE FAIL');
          } else {
            if (res.data.status != 'dupl') {
              this.saveConfirm();
            } else {
              this.$showAlert(res.data.errorMsg);
              return;
            }
          }
        })
        .catch(error => {
          console.log(error);
          return false;
        });
    },
  },
  option: {
    direction: 'horizontal',
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  p.desc {
    white-space: pre-wrap;
  }
}
.max-length-guide {
  font-weight: 400;
  font-size: 0.8rem;
  margin-left: 8px;
  opacity: 0.8;
}
.v-tab .v-btn {
  display: none;
}

.v-tab:hover .v-btn.hovering {
  display: inline-block;
}
.v-btn:not(.v-btn--round).v-size--x-small {
  position: absolute;
  right: 0px;
  min-width: 20px;
  padding: 0px;
  color: #bababa !important;
  font-weight: 400;
  font-size: 18px;
  background: transparent;
}

/* tab menu custom */
.v-slide-group__wrapper {
  padding: 4px;
}
.v-tabs-slider-wrapper {
  height: 40px !important;
  border-radius: 4px;
}
.v-tabs-slider {
  border: 1px solid #d4e3ec;
  border-radius: 4px;
  background-color: #ffffff !important;
}
.v-tab.v-tab--active {
  z-index: 100;
  font-weight: bold;
}
.theme--light.v-tabs .v-tab:hover {
  position: relative;
  font-weight: bold;
  color: #1976d2 !important;
}
.v-tab:before {
  transition: none !important;
}

.theme--light.v-tabs .v-tab:hover::before {
  border: 1px solid #0065bd;
  border-radius: 4px;
  background-color: #ffffff !important;
  opacity: 1 !important;
  z-index: -1;
  transition: none !important;
}
.theme--light.v-btn:hover::before,
.theme--light.v-btn:active::before {
  opacity: 0;
}

.v-tab {
  min-width: 100px !important;
}

@media screen and (max-width: 1300px) {
  .notice-wrap {
    width: 800px !important;
  }

  /* .notice-wrap .quick-menu {
    margin: 122px -560px 0 0 !important;
  } */
}

/* @media screen and (max-height: 754px) {
  .notice-wrap .quick-menu {
    top: 10.5% !important;
  }
} */
</style>
